
import React, { useEffect, useState, useMemo, useRef } from 'react';
import { FilterQueryParams } from '../../../../helpers';
import { Card, CardBody, HeaderTitle, MenuSVG, Table } from '../../../../components';
import { useSummariesContext } from '../context/SummariesUIContext';
import { UIHelpers } from '../../../../constants/pages/UIHelpers';
import SummariesColumns from './SummariesColumns';
import { reportsService, usersService } from '../../../../services';
import page from '../../../../constants/pages/page';
import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CollectionCustomFilters from './filters/SummariesCustomFilters';
import moment from 'moment';
import { downloadCSV } from '../../../../helpers/download';
import axios from 'axios';
import { checkFileStatus } from '../../../../helpers/fibonacciHelper';

const replaceCommaPattern = /\[([^,]+),([^,\]]+)\]/;

export default function SummariesTable () {
    // sortKeyMap
    const { t } = useTranslation();
    const { defaultSorted } = UIHelpers();

    const summariesFilterRef = useRef();

    // Context state

    const summariesUIContext = useSummariesContext();
    const summariesUIProps = useMemo(() => {
        return {
            isLoading: summariesUIContext.isLoading,
            setIsLoading: summariesUIContext.setIsLoading,
            queryParams: summariesUIContext.queryParams,
            setQueryParams: summariesUIContext.setQueryParams
        };
    }, [summariesUIContext]);

    // List state
    const [summaries, setSummaries] = useState([]);

    // Modal state

    // Transaction detail state

    // Functions

    async function fetchSummaries (download, page) {
        // change state isLoading
        summariesUIProps.setIsLoading(true);

        // Prepare options (order, pages and filters)
        const filters = summariesUIProps.queryParams.filters || new FilterQueryParams();

        const options = {
            order: 'id_statement-DESC',
            pageSize: download || summariesUIProps.queryParams.pageSize,
            page: page || summariesUIProps.queryParams.pageNumber,
        };

        // Set filters on options.
        options.filters = filters.build();
        await usersService.getSummaries(options)
            .then(summaries => {
                setSummaries(summaries);
            })
            .catch(e => {
                console.error(e);
                return [];
            })
            .finally(() => {
                summariesUIProps.setIsLoading(false);
            });
    };

    const replaceComma = (match, p1, p2) => {
        return `[${p1};${p2}]`;
    };

    const getDownloadFilters = () => {
        if (!JSON.stringify(summariesUIProps?.queryParams?.filters?.filters)) return '';
        const filters = { ...summariesUIProps?.queryParams?.filters?.filters };
        delete filters.emision_date;
        return JSON.stringify(filters)
            .replace(/[{}"]/g, '')
            .replace(/:/g, ' ')
            .replace(replaceCommaPattern, replaceComma);
    };

    const download = async () => {
        summariesUIProps.setIsLoading(true);

        const fetchFile = (idFile) => {
            return checkFileStatus({ filters: `id eq ${idFile}` }, 60, 3);
        };
        const startDate = summariesUIProps.queryParams?.filters?.filters?.emision_date?.be[0] || moment().subtract(730, 'days').format('YYYY-MM-DD HH:mm:ss');
        const endDate = summariesUIProps.queryParams?.filters?.filters?.emision_date?.be[1] || moment().format('YYYY-MM-DD HH:mm:ss');
        const filters = (summariesUIProps.queryParams?.filters?.filters?.emision_date?.be[0] ? (`emision_date be [${startDate};${endDate}]`) : '') + ((summariesUIProps.queryParams?.filters?.filters?.emision_date?.be[0] && getDownloadFilters()) ? `,${getDownloadFilters()}` : getDownloadFilters() || '');

        const options = {
            idType: 29,
            startAt: startDate,
            endAt: endDate,
            metadata: {
                filters,
                order: 'id_statement-DESC',
            }
        };

        const nameTable = window.location.pathname.slice(1, window.location.pathname.length);
        const fileName = summariesUIProps.queryParams?.filters?.filters?.emision_date?.be[0] ? `Reporte del ${options.startAt} al ${options.endAt} ${nameTable}.csv` : `Reporte ${nameTable}.csv`;
        await reportsService
            .createReport(options)
            .then(async (response) => {
                return await fetchFile(response.metadata.id_file);
            })
            .then(async (res) => {
                return await axios.get(res[0].description, { responseType: 'arraybuffer' });
            }
            )
            .then((response) => {
                summariesUIProps.setIsLoading(false);
                downloadCSV(response.data, fileName);
            })
            .catch(() => {
                summariesUIProps.setIsLoading(false);
            });
    };

    const resetFilters = () => {
        if (summariesFilterRef.current) {
            summariesFilterRef.current.reset();
        }
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(() => summariesUIProps.setQueryParams(prev => ({ ...prev, pageSize: localStorage.getItem('sizePerPage') || page.pageSize })), []);

    useEffect(() => {
        if (JSON.stringify(summariesUIProps.queryParams.url) !== undefined) {
            fetchSummaries();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [summariesUIProps.queryParams]);

    // Main Component

    return (

        <Card>
            <Box >
                <HeaderTitle
                    title={t('summary.table.title')}
                    download={download}
                    reset={resetFilters}
                    icon={(<MenuSVG className='mr-1 mb-2' />)}
                    UIProps={summariesUIProps}
                />
                <CollectionCustomFilters
                    ref={summariesFilterRef}
                />
            </Box>
            <CardBody>
                <Table
                    data={summaries?.statements}
                    columns={SummariesColumns({ download })}
                    total={summaries?.totalRecords}
                    sort={defaultSorted}
                    onChange={summariesUIProps.setQueryParams}
                    isLoading={summariesUIProps.isLoading}
                    pagination={{
                        sizePerPage: summariesUIProps.queryParams.pageSize,
                        page: summariesUIProps.queryParams.pageNumber
                    }}
                />
            </CardBody>
        </Card>
    );
};
